// NavButton - Sidebar navigation button component
import React from 'react';

const NavButton = ({ active, onClick, icon: Icon, label }) => (
    <button
        onClick={onClick}
        title={label}
        aria-label={label}
        className={`group flex h-14 w-14 flex-col items-center justify-center rounded-2xl outline-none transition-all duration-300 focus-visible:ring-2 focus-visible:ring-[#2563EB]/30 ${active
            ? 'bg-[#EBF2FF] text-[#3B82F6] shadow-sm'
            : 'text-[#8A90A5] hover:bg-white hover:text-[#4A4F63]'
            }`}
    >
        <Icon
            className={`mb-1 h-6 w-6 transition-transform group-hover:scale-110 ${active ? 'scale-105' : ''}`}
            strokeWidth={active ? 2.4 : 2}
        />
        <span className={`text-[10px] font-bold ${active ? 'text-[#3B82F6]' : 'text-[#A0A6BA]'}`}>{label}</span>
    </button>
);

export default NavButton;
